// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2aDYd","consentsList":"PatientConsents_consentsList__3mgGp","consentsListEmpty":"PatientConsents_consentsListEmpty__1Bx9T"};